/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FullWidthECGPreview from '../../components/FullWidthECGPreview';
import styles from './AllLeadView.css'
import {selectLead} from '../../state'

const AllLeadView = () => {
    const Samples = useSelector((state) => state.annotator.samples)
    const Beats = useSelector((state) => state.annotator.interpretation.beats)
    const dispatch = useDispatch()

    const onSelectLead = (leadName) =>{
        dispatch(selectLead(leadName))
    }
    return (
        <div className={styles.LeadViewContainer}>
            <div className={styles.LeadViewHeading}>
                <h2 className={styles.headingText}>Full 30s Strip</h2>
            </div>
            {Object.keys(Samples.samples).map(leadName =>(
                <div key={leadName} className={styles.ecgRowView}>
                    <div className={styles.ecgRowButtonCol}>
                        <button className={styles.openLeadButton} onClick={()=>onSelectLead(leadName)}> > </button>
                    </div>
                    <div className={styles.ecgRowPreviewCol}>
                        <FullWidthECGPreview 
                            ecgTitle = {leadName}
                            enableBeats = {true}
                            sample = {Samples.samples[leadName]}
                            beats = {Beats}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default AllLeadView



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AllLeadView/AllLeadView.jsx